module.exports = __webpack_public_path__ + "static/media/ic-orders.3c2575f0.svg";